import { publishUrl } from './PublishStore';

export const updatePublishUrl = (value) => publishUrl.update((oldValue) => value);
